// extracted by mini-css-extract-plugin
module.exports = {"ziplineTabs":"ZiplineTabs_ziplineTabs___nd3Y","tab":"ZiplineTabs_tab__3wAXM"};